import "./App.css";
import { Routes, Route } from "react-router-dom";
import { PublicRoutes } from "@routing/PublicRoutes/PublicRoutes.jsx";

function App() {
  return (
    <div className="App">
      <Routes>
        {PublicRoutes.map((route) => (
          <Route key={route.key} path={route.path} element={route.element} />
        ))}
      </Routes>
    </div>
  );
}

export default App;
